import "./components/item/ItemImageCarousel";
import "./components/form/ItemQuestion";
import "./components/item/Carousel";
import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';


function initRatingSlider(){

    if($('.splide-slider-customer-rating').length > 0){
        new Splide('.splide-slider-customer-rating', {
            perPage: 1,
            gap    : '15px',
            pagination: false,
            arrows: true,
            mediaQuery: 'min',
            breakpoints:{
                576: {
                    perPage: 2,
                },
                992: {
                    gap : '30px', 
                    perPage: 3,
                }
            }
            
        }).mount(); 
    }
}
function initBannerCatsSlider(){
    if($('.splide-slider-cats').length > 0){
        new Splide('.splide-slider-cats', {
            fixedWidth: '200px',
            drag   : 'free',
            gap    : '30px',
            mediaQuery: 'min',
            pagination: false,
            arrows: false,
            breakpoints:{
                768: {
                    perPage: 3,
                    fixedWidth: false,
                    arrows: true
                }
            }
          }).mount();
    }
}
function initBrandSlider(){
    if($('.list-brands-slide').length > 0){
        new Splide('.list-brands-slide', {
            perPage: 2,
            drag   : 'free',
            gap    : '15px',
            mediaQuery: 'min',
            pagination: false,
            arrows: false,
            autoScroll: {
                speed: 1,
                pauseOnHover: true
            },
            breakpoints:{
                768: {
                    perPage: 3
                },
                992: {
                    perPage: 4
                },
                1200: {
                    perPage: 6
                },
                1410: {
                    perPage: 7
                }
            }
          }).mount({ AutoScroll });
    }
}
function initEmpfehlungSlider(){
    if($('.splide-empfehlung-slider-item').length > 0){
        new Splide('.splide-empfehlung-slider-item',{
            fixedWidth: '180px',
            drag   : 'free',
            gap    : '30px',
            perPage: 1,
            arrows: false,
            gap    : '15px',
            mediaQuery: 'min',
            pagination: false,
            breakpoints:{
                768: {
                    perPage: 1,
                    fixedWidth: false,
                    pagination: true
                }
            }
        }).mount();
    }
}
document.onreadystatechange = function () {
    if (document.readyState == "complete") {
        initEmpfehlungSlider();
    }
}
$(document).ready(function(){
    initRatingSlider();
    initBannerCatsSlider();
    initBrandSlider();
  
})
var timeoutHandle;
$(document).on("mouseenter",".mainmenu > .ddown", function () {
    if(window.innerWidth >= 992){
        var _this = this;
        timeoutHandle = setTimeout(function(){ 
             $(_this).addClass('isHover');
         }, 300); 
    }
    
});
$(document).on("mouseleave",".mainmenu > .ddown", function () {
    if(window.innerWidth >= 992){
        var _this = this;
        clearTimeout(timeoutHandle);
        //setTimeout(function(){ 
            $(_this).removeClass('isHover');
        //}, 300);
    }
});
$('.btnFilterLetter').on('click', function(event) { 
    var conti = $(this).closest('.nav-brands');
    $('.btnFilterLetter').not(this).removeClass('active');
    $(this).toggleClass('active');
    
    if($(this).hasClass('active')){
        var _this = this;
        $(conti).addClass('activeLetterFilter');
        $('.navBrandListTxt li', conti).hide().filter(function(){
           return $(this).data('letter') == $(_this).data('letter');
        }).show()
    }else{
        $(conti).removeClass('activeLetterFilter');
        $('.navBrandListTxt li').hide();
        $('.navBrandListTxt li.activeStandart', conti).show();
    }
    
});
$(document).on('click', '.btnFilterLetterContent', function(event) { 
    var activeLetter = $(this).data('letter');
    var scrollHeight = $(`[data-scrollletter="${activeLetter}"]`).offset().top - $('#page-header').height() - 30 - $('.brand-letters-sticky').outerHeight();
    $("html, body").animate({ 
        scrollTop: scrollHeight }, 
    1000);
    /*var conti = $(this).closest('.brand-content');
    $('.btnFilterLetterContent').not(this).removeClass('active');
    $(this).toggleClass('active');
    
    if($(this).hasClass('active')){
        var _this = this;
        $(conti).addClass('activeLetterFilter');
        $('.brand-tab-content li', conti).hide().filter(function(){
           return $(this).data('letter') == $(_this).data('letter');
        }).show()
    }else{
        $(conti).removeClass('activeLetterFilter');
        $(conti).find('li').show();
    }*/
    
});
$(document).on('click', '.btn-open-filter, .btn-close-filter', function(event) { 
    $('body').toggleClass('filter-open')
});

$(document).on('click', '.copy-code', function(event){      

    var copyText = document.getElementById("copy-txt-clip");
    navigator.clipboard.writeText(copyText.innerHTML);
    $('.copy-code').addClass('has-copied')
    return false;
});

let lastScrollTop = 0;
const header = document.getElementById('page-header');

window.addEventListener('scroll', function() {
    if($(window).outerWidth() < 768){
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (scrollTop > lastScrollTop) {
            // Scrolling down
            header.classList.add('header-hidden');
        } else {
            // Scrolling up
            header.classList.remove('header-hidden');
        }
        lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // For Mobile or negative scrolling
    }
});